import Vue from "vue";
import * as filters from "@/filters";
import { appConfig } from "@/config";

import { NODE_ENVS } from "@/constants";
import * as images from "@/assets/images";
import * as dictionary from "@/dictionary";

import globalComponents from "@/components/global";
import paths from "@/constants/route-paths";
import * as injectables from "@/injectables";

/**
 * All the injectables and services to be injected in the vue globally
 * @todo import and add  services or the modules that needs to be injected
 * and to be used in the vue globally
 */
const injectablesObj = {
  paths,
  images,
  appConfig,
  dictionary,
  ...injectables,
};

/**
 * Iterates over all the injectablesObj object and injects them globally in the vue instance
 */
export const injectInjectables = () => {
  for (const key in injectablesObj) {
    Vue.prototype[`$${key}`] = injectablesObj[key];
  }
};

/**
 * Registers components globally
 * @description these components can be used gloabally wihtout importing them locally in the component
 */
export const registerGlobalComponents = () => {
  // Iterates and regiters components globally
  for (const key in globalComponents) {
    Vue.component(key, globalComponents[key]);
  }
};

/**
 * Injects filters globally in the vue globally
 * @description Iterates over all the filters and then injects them globally
 */
export const injectFilters = () => {
  // Iterates over all the filters
  for (const key in filters) {
    Vue.filter(key, filters[key]);
  }
};

/**
 * Determines if the node_env is development or not
 * @returns {Boolean} Is env development or not
 */
export const isDevEnv = () => process.env.NODE_ENV === NODE_ENVS.dev;

/**
 * Throws an error if the required param or argument of a function is not passed
 * @param {String} paramName function parameter which is required
 * @returns {Error} error details of required param
 */
export const required = (paramName) => {
  throw new Error(`${paramName} parameter is required.`);
};

/**
 * Rejects promise with the error
 * @param {Object} error Error with which promise will be rejected
 * @returns {Promise} Rejected Promise
 */
export const rejectPromise = (error) => Promise.reject(error);
